import { IsBoolean, IsEnum, IsISO8601, IsOptional, IsString, IsUUID } from 'class-validator';

import { ConnectionStatus, ProviderType } from './enums';
import { SensorDto } from './sensor.dto';

export class SourceDto {
  @IsUUID()
  id!: string;

  @IsUUID()
  externalId!: string;

  @IsEnum(ProviderType)
  providerType!:
    | 'libreview'
    | 'dexcom'
    | 'libreview-csv'
    | 'dexcom-csv'
    | 'fslibre-json'
    | 'virtual'
    | 'libre-view-api';

  @IsString()
  providerName!: string;

  @IsBoolean()
  liveData!: boolean;

  @IsString()
  timestampIn!: string;

  @IsEnum(ConnectionStatus)
  status!: ConnectionStatus | null;

  /** internal: when has dashboard been refreshed? */
  @IsISO8601()
  lastStatusRefreshTime!: string;

  /** internal: when was the last full refresh (inluding source and raw values) done? */
  @IsISO8601()
  lastDataRefreshTime?: string | null;

  /** external: for what time API says most recent data is available */
  @IsISO8601()
  lastStatusValueTime?: string | null;

  /** deprecated, use lastStatusValueTime */
  @IsISO8601()
  lastGlucoseDataApi?: string;

  /** external: timestamp of the most recent glucose value that has been imported into the service */
  @IsISO8601()
  lastDataValueTime?: string;

  /** deprecated, use lastDataValueTime */
  @IsISO8601()
  lastGlucoseValueTimeApi?: string | null;

  @IsString()
  @IsOptional()
  emailOverride?: string;

  sensors: SensorDto[];

  constructor(sensors: SensorDto[]) {
    this.sensors = sensors;
  }
}
